<template>
    <div :id="id">
        <h3 class="mt-0">{{ item.name }}</h3>
        <p class="text-justify" v-if="item.description">
            <strong v-if="progressCheck">{{ lang.polaris.dashboard.progress_check }} - </strong>
            {{ item.description }}
        </p>
        <p v-else-if="progressCheck">
            <strong>{{ lang.polaris.dashboard.progress_check }}</strong>
        </p>

        <div v-html="statusHtml"></div>

        <div class="text-center mt-4">
            <a :href="viewLink" class="btn btn-round btn-default">
                {{ lang.polaris.dashboard.details }}
            </a>
            <a :href="editLink" class="btn btn-round btn-primary" v-if="editAllowed">
                {{ lang.polaris.dashboard.edit }}
            </a>
        </div>
    </div>
</template>

<script>
    export default {
    
        props: {
            id: null,
            bus: null
        },
    
        data: function() {
            return {
                lang: lang,
                user: user,
                registration: data.registration,
                learning_unit_dashboard_routes: data.learning_unit_dashboard_routes,
                item: {meta: {}}
            }
        },

        computed: {

            editAllowed: function() {
                return this.item.type == 'enac-atpl-course-session' && !this.item.meta.assessment && this.editDashboardPermission && this.editDashboardStatus;
            },
        
            statusHtml: function() {
                if (!this.item.state) return '';
                var html = '<div class="text-center mb-5">';

                var color = '#4caf50';  // Success
                if (this.item.state.color_status == 'danger') color = '#f44336';
                if (this.item.state.color_status == 'warning') color = '#ff9800';

                html += '<span class="peity donut" data-peity=\'{ "fill": ["'+color+'", "#eeeeee"], "innerRadius": 20, "radius": 24 }\'>';
                html += (this.item.state.completion.percent-1) + '/100</span>';
                html += '<small class="ml-1">'+this.statusLabel+'</small></div>';
                return html;
            },
        
            statusLabel: function() {
                var label = this.item.state.completion.percent+'% '+this.lang.polaris.dashboard.completed_lc;
                if (this.item.state.success.failed.count) {
                    label += ', '+this.item.state.success.failed.count+' '+this.lang.polaris.dashboard.failed_lc;
                } else if (this.item.state.success.partially_passed.count) {
                    label += ', '+this.item.state.success.partially_passed.count+' '+this.lang.polaris.dashboard.partially_passed_lc;
                } else if (this.item.state.success.passed.count) {
                    label += ' '+this.lang.polaris.dashboard.and_passed_lc;
                } 
                return label;
            },

            completed: function() {
                return this.item.state && this.item.state.completed;
            },
        
            progressCheck: function() {
                return this.item.meta.assessment;
            },
        
            viewLink: function() {
                var routes = this.learning_unit_dashboard_routes;
                return routes[this.item.type]+'/registration/'+this.registration.id+'/'+this.item.type+'/'+this.item.id;
            },
        
            editLink: function() {
                return this.viewLink + '/edit';
            },

            editDashboardPermission: function() {
                return this.user.admin || this.user.permissions['dashboard.write-all'] || this.user.permissions['dashboard.write-mine-locations'];
            },

            editDashboardStatus: function() {
                return this.registration.status != 'draft' && this.registration.status != 'archived';
            }
        },

        created: function() {
            this.bus.$on(this.id+'-open', this.open);
        },

        updated: function() {
            $("#"+this.id+" .peity.donut").peity("donut");
        },
        
        methods: {
        
            open: function(event) {
                this.item = event.data;
            }

        }

    }
</script>
